import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-403cbc0b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "Courses__Backgrounds" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "color--1" }, null, -1))
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = { class: "Courses__Wrapper" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", { viewBox: "0 0 11 19" }, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#i-question-mark" })
], -1))
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = { class: "Courses__Grid" }
const _hoisted_8 = { class: "Courses__Categories small-uppercase" }
const _hoisted_9 = { class: "color--3" }
const _hoisted_10 = {
  key: 0,
  class: "color--3"
}
const _hoisted_11 = { class: "Courses__List__Wrapper" }
const _hoisted_12 = { class: "Courses__List" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Item = _resolveComponent("Item")!
  const _component_Nav = _resolveComponent("Nav")!
  const _component_Chapters = _resolveComponent("Chapters")!
  const _component_MobileShortcuts = _resolveComponent("MobileShortcuts")!
  const _component_LayoutConnected = _resolveComponent("LayoutConnected")!

  return (_openBlock(), _createBlock(_component_LayoutConnected, null, {
    default: _withCtx(() => [
      _createElementVNode("main", {
        class: _normalizeClass(["Courses", [_ctx.isScrolling ? 'is-scrolling' : '', 'Courses--state-'+this.state]])
      }, [
        _createElementVNode("ul", _hoisted_1, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.courses, (course) => {
            return (_openBlock(), _createElementBlock("li", {
              key: 'item--'+course.slug,
              class: _normalizeClass(['theme--' + course.theme, _ctx.current === course ? 'active': ''])
            }, _hoisted_3, 2))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("button", {
            class: _normalizeClass(["Courses__TutorialTrigger", { 'dark': _ctx.themeForceDark }]),
            type: "button",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.showTutorial && _ctx.showTutorial(...args)))
          }, _hoisted_6, 2),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("ul", _hoisted_8, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.courses, (course) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: 'item--'+course.slug,
                  class: _normalizeClass(['theme--' + course.theme, _ctx.current === course ? 'active': ''])
                }, [
                  _createElementVNode("div", _hoisted_9, _toDisplayString(course.categoryName), 1),
                  (course.type === 'course')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(_ctx.$t('course.module_number', { number: course.number })), 1))
                    : _createCommentVNode("", true)
                ], 2))
              }), 128))
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("ul", _hoisted_12, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.courses, (course, index) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: 'item--'+course.slug
                  }, [
                    _createVNode(_component_Item, {
                      hidden: (this.state === 'course' && _ctx.current !== course),
                      course: course,
                      current: _ctx.current,
                      courses: _ctx.courses,
                      isScrolling: _ctx.isScrolling,
                      index: index,
                      gap: _ctx.gap,
                      rotation: _ctx.rotation
                    }, null, 8, ["hidden", "course", "current", "courses", "isScrolling", "index", "gap", "rotation"])
                  ]))
                }), 128))
              ]),
              _createVNode(_component_Nav, {
                class: "Courses__Nav",
                hidden: this.state === 'course',
                rotation: _ctx.rotation,
                max: (_ctx.courses.length - 1) * _ctx.gap,
                gap: _ctx.gap,
                onGoLeft: _cache[1] || (_cache[1] = ($event: any) => (_ctx.goLeft())),
                onGoRight: _cache[2] || (_cache[2] = ($event: any) => (_ctx.goRight()))
              }, null, 8, ["hidden", "rotation", "max", "gap"])
            ])
          ]),
          _createVNode(_component_Chapters, {
            state: _ctx.state,
            chapters: _ctx.current && _ctx.current.chapters,
            course: _ctx.current
          }, null, 8, ["state", "chapters", "course"])
        ]),
        _createVNode(_component_MobileShortcuts, {
          hidden: this.state === 'course'
        }, null, 8, ["hidden"])
      ], 2)
    ]),
    _: 1
  }))
}